import React from 'react';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

export interface PasswordProgressBarProps {
  value: string;
}
const colorProgressBar = (value: string) => {
  if (value.length === 0) {
    return '#E7E8ED';
  } else if (value.length < 5) {
    return '#F55235';
  } else if (value.length < 10) {
    return '#F3C84B';
  } else {
    return '#32C284';
  }
};
const valueProgressBar = (value: string) => {
  if (value.length === 0) {
    return 0;
  } else if (value.length < 5) {
    return 20;
  } else if (value.length < 10) {
    return 50;
  } else {
    return 100;
  }
};
const PasswordProgressBar = (props: PasswordProgressBarProps) => {
  const { value } = props;

  const BorderLinearProgress = withStyles((theme: Theme) =>
    createStyles({
      root: {
        height: 10,
      },
      colorPrimary: {
        backgroundColor:
          theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
      },
      bar: {
        backgroundColor: colorProgressBar(value),
      },
    }),
  )(LinearProgress);

  return (
    <BorderLinearProgress
      variant="determinate"
      value={valueProgressBar(value)}
    />
  );
};
export default PasswordProgressBar;
